'use client';
import React from 'react';
import { TrackingInfo as Shared } from '@launchstore/shared-puck';
import { useOrderData } from '@/lib/hooks/useOrderData';

const SharedRender = (Shared as any).render;

/**
 * Storefront TrackingInfo — injects carrier + tracking number from the order's
 * fulfillments/shipping method. Falls back to the shared placeholder when no
 * order (or no fulfillment yet) is present.
 */
function TrackingInfoImpl(props: any) {
  const { order } = useOrderData();
  if (!order) {
    return <SharedRender {...props} />;
  }
  const fulfillment = (order as any).fulfillments?.[0];
  const label = fulfillment?.labels?.[0];
  const trackingNumber = label?.tracking_number;
  const carrier = order.shipping_methods?.[0]?.name;

  return (
    <SharedRender
      {...props}
      carrier={carrier}
      trackingNumber={trackingNumber}
    />
  );
}

export const TrackingInfo: any = {
  ...Shared,
  render: (props: any) => <TrackingInfoImpl {...props} />,
};

export default TrackingInfo;
